import { Box, Chip, Divider, TextField } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { isNil } from "lodash";
import React from "react";

import PreliminaryWorkAPI from "../api/PreliminaryWork.api";
import { Harvest } from "../types";
import ListingDateWithMaterials from "./ListingDateWithMaterials";
import PrefieldMaterials from "./PrefieldMaterials";
import PreliminaryWorkHarvestWrapper from "./PreliminaryWorkHarvestWrapper";
import SoilAnalysis from "./SoilAnalysis";

export default function HarvestFieldWorkReportTabPreliminaryWork({
  harvest,
  disabled,
}: {
  harvest: Harvest;
  disabled: boolean;
}) {
  const [soilAnalysisComments, setSoilAnalysisComments] =
    React.useState<string>(
      harvest?.preliminaryWork?.soilAnalysisComments || "",
    );
  const [prefieldAnalysisComments, setPrefieldAnalysisComments] =
    React.useState<string>(
      harvest?.preliminaryWork?.prefieldAnalysisComments || "",
    );
  const [listingDate, setListingDate] = React.useState<Dayjs | null>(
    harvest?.preliminaryWork?.listingDate
      ? dayjs(harvest.preliminaryWork.listingDate)
      : null,
  );

  React.useEffect(() => {
    if (!isNil(harvest.preliminaryWorkId)) {
      setSoilAnalysisComments(
        harvest?.preliminaryWork?.soilAnalysisComments || "",
      );
      setPrefieldAnalysisComments(
        harvest?.preliminaryWork?.prefieldAnalysisComments || "",
      );
      setListingDate(
        harvest?.preliminaryWork?.listingDate
          ? dayjs(harvest.preliminaryWork.listingDate)
          : null,
      );
    }
  }, [disabled, harvest]);
  return (
    <PreliminaryWorkHarvestWrapper
      input={{
        id: harvest.preliminaryWorkId,
        listingDate: listingDate
          ? listingDate?.format("YYYY-MM-DD")
          : listingDate,
        soilAnalysisComments,
        prefieldAnalysisComments,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Divider>
          <Chip label="Soil Analysis" />
        </Divider>
        <SoilAnalysis
          parentId={harvest.preliminaryWorkId}
          soilAnalysisFiles={harvest.preliminaryWork?.soilAnalysisFiles}
          useUploadFile={PreliminaryWorkAPI.useUploadFile}
        />
        <TextField
          label="Soil Analysis Comments"
          multiline
          rows={4}
          value={soilAnalysisComments}
          onChange={(e) => setSoilAnalysisComments(e.target.value)}
          disabled={disabled}
          fullWidth
        />
        <Divider>
          <Chip label="Prefield Work" />
        </Divider>
        <TextField
          label="Prefield Analysis Comments"
          multiline
          rows={4}
          value={prefieldAnalysisComments}
          onChange={(e) => setPrefieldAnalysisComments(e.target.value)}
          disabled={disabled}
        />
        <PrefieldMaterials
          actualNumAcres={harvest.lotableNumOfAcres}
          materialApplicableId={harvest.preliminaryWorkId}
          materialApplicableType={"PreliminaryWork"}
        />
        <Divider>
          <Chip label="Field Work" />
        </Divider>
        <ListingDateWithMaterials
          actualNumAcres={harvest.lotableNumOfAcres}
          materialApplicableId={harvest.preliminaryWorkId}
          materialApplicableType={"PreliminaryWork"}
          listingDate={listingDate}
          setListingDate={setListingDate}
        />
      </Box>
    </PreliminaryWorkHarvestWrapper>
  );
}
